import { Helmet } from 'react-helmet-async';

const HomePageHelmet = () => {
  return (
    <Helmet>
      <title>Interlink Oceana - Simplifying Global Shipments</title>
      <meta content='Streamline your shipping process with Interlink Oceana. Explore reliable shipment solutions designed to connect businesses globally with efficiency and precision.' />
      <meta property='og:type' content='website' />
      <meta property='og:url' content='https://www.interlinkoceana.com' />
      <meta
        property='og:title'
        content='Interlink Oceana - Your Global Shipping Partner'
      />
      <meta
        property='og:image'
        content='https://www.interlinkoceana.com/assets/img/inter-i-logo.png'
      />
      <meta
        property='og:description'
        content='Streamline your shipping process with Interlink Oceana. Explore reliable shipment solutions designed to connect businesses globally with efficiency and precision.'
      />
      <meta
        name='keywords'
        content='shipping, global shipments, logistics, freight forwarding, international shipping, cargo solutions, Interlink Oceana, shipment services, supply chain management'
      />
      <meta
        name='description'
        content='Streamline your shipping process with Interlink Oceana. Explore reliable shipment solutions designed to connect businesses globally with efficiency and precision.'
      />
      <meta property='og:site_name' content='Interlink Oceana' />
      <meta property='og:locale' content='en_US' />
      <link rel='canonical' href='https://www.interlinkoceana.com' />
    </Helmet>
  );
};

export default HomePageHelmet;
